<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'

import HelpersGrid from './HelpersGrid.vue'
import HelperPushCard from './HelperPushCard.vue'
import HelperActionRow from './HelperActionRow.vue'

defineOptions({
  name: 'HelpersPage',
})
</script>

<template>
  <HelpersGrid>
    <HelperPushCard />
    <CardAdmin
      title="Notifications"
      fullwidth
    >
      <HelperActionRow
        label="Send tutor no show notifications"
        route-name="admin.helpers.notifications.tutor-no-show"
      />
    </CardAdmin>
    <CardAdmin
      title="Demo Extra Rates"
      fullwidth
    >
      <HelperActionRow
        label="Send extra rates applied notifications"
        route-name="admin.helpers.extra-rates.send-applied-notifications"
      />
      <HelperActionRow
        label="Send remaining extra demo slots notifications"
        route-name="admin.helpers.extra-rates.send-remaining-slots-notifications"
      />
    </CardAdmin>
  </HelpersGrid>
</template>
